(() => {
  const setupStickyBar = (section) => {
    const stickyAdd = section.querySelector("[data-pdp-sticky-add]");
    const mainAdd = section.querySelector("[data-pdp-add-to-cart]");

    if (!stickyAdd || !mainAdd) return;

    const syncState = () => {
      stickyAdd.disabled = mainAdd.disabled;
      const text = mainAdd.textContent ? mainAdd.textContent.trim() : "";
      if (text) stickyAdd.textContent = text;
    };

    syncState();

    const observer = new MutationObserver(syncState);
    observer.observe(mainAdd, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    stickyAdd.addEventListener("click", (event) => {
      event.preventDefault();
      if (mainAdd.disabled) return;
      mainAdd.click();
    });
  };

  const setupIndicators = (section) => {
    const indicators = section.querySelector("[data-pdp-indicators]");
    const mediaList = section.querySelector(".pdp-media .product__media-list");

    if (!indicators || !mediaList) return;

    const slides = Array.from(mediaList.children).filter((item) =>
      item.classList.contains("product__media-item")
    );

    if (slides.length <= 1) {
      indicators.innerHTML = "";
      return;
    }

    indicators.innerHTML = "";
    const buttons = slides.map((_, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className =
        "pdp-media__indicator" +
        (index === 0 ? " pdp-media__indicator--active" : "");
      button.setAttribute("aria-label", `Vai alla immagine ${index + 1}`);
      button.addEventListener("click", () => {
        slides[index].scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });
      });
      indicators.appendChild(button);
      return button;
    });

    let ticking = false;
    const updateActive = () => {
      if (!window.matchMedia("(max-width: 768px)").matches) return;
      const width = mediaList.clientWidth || 1;
      const index = Math.min(
        buttons.length - 1,
        Math.max(0, Math.round(mediaList.scrollLeft / width))
      );
      buttons.forEach((button, i) => {
        button.classList.toggle("pdp-media__indicator--active", i === index);
      });
    };

    mediaList.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateActive();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener("resize", updateActive);
    updateActive();
  };

  const initSection = (section) => {
    setupStickyBar(section);
    setupIndicators(section);
  };

  const init = () => {
    document
      .querySelectorAll('[data-section-type="main-product-pdp-v2"]')
      .forEach((section) => {
        initSection(section);
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target;
    if (
      section &&
      section.dataset &&
      section.dataset.sectionType === "main-product-pdp-v2"
    ) {
      initSection(section);
    }
  });
})();
